<template>
  <div>
    <countdown v-if="currentStage === 'countdown'" @startGame="startGame" />
    <puzzle
      v-if="currentStage === 'puzzle'"
      :key="puzzleNumber"
      :number="puzzleNumber"
      :name="`/trailo/T-5-${puzzleNumber}.jpg`"
      :options="['A', 'B', 'C', 'D', 'E', 'F', 'Z']"
      :keyboard="false"
      :countdown="false"
      :magnify="true"
      @complete="puzzleComplete"
    />
    <pause
      v-if="currentStage === 'pause'"
      :solution="solution[puzzleNumber - 1]"
      :legCorrect="lastLegCorrect"
      @nextPuzzle="nextPuzzle"
    />
    <game-over
      v-if="currentStage === 'gameover'"
      :user="''"
      :time="userScore"
    />
  </div>
</template>

<script>
import Countdown from '@/components/Countdown'
import Puzzle from '@/components/Puzzle'
import Pause from '@/components/Pause'
import GameOver from '@/components/GameOver'

export default {
  components: {
    Countdown,
    Puzzle,
    Pause,
    GameOver,
  },

  data: function() {
    return {
      puzzleNumber: 1,
      currentStage: 'puzzle',
      choices: [],
      times: [],
      userScore: '',
      userScoreNumber: 0,
      userTime: 0,
      solution: ['C', 'E', 'Z', 'B', 'D'],
    }
  },

  computed: {
    lastLegCorrect: function() {
      return (
        this.solution[this.puzzleNumber - 1] ===
        this.choices[this.puzzleNumber - 1]
      )
    },
  },

  methods: {
    startGame: function() {
      this.currentStage = 'puzzle'

      if (this.puzzleNumber >= this.solution.length) {
        this.currentStage = 'gameover'

        this.userTime = this.times.reduce((a, b) => a + b, 0)
        this.userScore = this.scoreUser()
      }
    },

    puzzleComplete: function(result) {
      this.choices.push(result.choice)
      this.times.push(result.time)

      this.currentStage = 'pause'
    },

    nextPuzzle: function() {
      if (this.puzzleNumber >= this.solution.length) {
        this.currentStage = 'gameover'

        this.userTime = this.times.reduce((a, b) => a + b, 0)
        this.userScore = this.scoreUser()
      } else {
        this.puzzleNumber += 1
        this.currentStage = 'puzzle'
      }
    },

    scoreUser: function() {
      let correct = 0
      let i = 0

      while (i < this.choices.length) {
        if (this.solution[i] === this.choices[i]) correct += 1
        i += 1
      }

      this.userScoreNumber = correct
      return this.userTime + (this.choices.length - correct) * 30000
    },

    displayTime: function(milliseconds) {
      const minutes = Math.floor(milliseconds / 60000)
      const millisecondsOverMinutes = milliseconds - minutes * 60000
      const seconds = Math.round(millisecondsOverMinutes / 10) / 100

      return `${this.twoDigits(minutes)}:${this.twoDigits(seconds)}`
    },

    twoDigits: function(number) {
      const splitNumber = number.toString().split('.')
      if (splitNumber.length > 1 && splitNumber[0].toString().length < 2)
        return `0${splitNumber[0].toString()}.${splitNumber[1]}`
      else if (number.toString().length < 2) return `0${number.toString()}`
      else return number
    },
  },
}
</script>
